<template>
  <a-modal
    :visible="visible"
    :footer="null"
    :closable="true"
    :maskClosable="false"
    width="1000px"
    :body-style="{ padding: '40px 60px', height: '500px' }"
    centered
    class="forget-password-modal"
    @cancel="handleCancel"
  >
    <div class="forget-modal-content">
      <div class="modal-header">
        <div class="modal-title">忘记密码</div>
      </div>

      <!-- Step 1: Verify Phone -->
      <div v-if="step === 1" class="step-content">
        <a-form-model
          ref="step1Form"
          :model="form"
          :rules="rules"
          layout="inline"
          class="step-form"
        >
          <a-row type="flex" justify="space-between" style="width: 100%; margin-bottom: 60px;">
            <a-col :span="11">
              <a-form-model-item label="登录手机号" prop="phone" style="width: 100%">
                <a-input
                  v-model="form.phone"
                  placeholder="请填写登录手机号"
                  size="large"
                  style="width: 240px"
                />
              </a-form-model-item>
            </a-col>
            <a-col :span="11">
              <a-form-model-item label="验证码" prop="code" style="width: 100%">
                <VerifyCodeInput
                  ref="verifyCodeInput"
                  v-model="form.code"
                  :phone-number="form.phone"
                  :sms-code-type="smsCodeType"
                  send-type="findPassword"
                  style="width: 240px"
                />
              </a-form-model-item>
            </a-col>
          </a-row>
          
          <div class="form-action-center">
            <a-button type="primary" size="large" class="action-btn" @click="handleNextStep">下一步</a-button>
          </div>
        </a-form-model>
      </div>

      <!-- Step 2: Reset Password -->
      <div v-if="step === 2" class="step-content">
        <a-form-model
          ref="step2Form"
          :model="form"
          :rules="rules"
          layout="inline"
          class="step-form"
        >
          <a-row type="flex" justify="space-between" style="width: 100%; margin-bottom: 60px;">
            <a-col :span="11">
              <a-form-model-item label="设置密码" prop="newPassword" style="width: 100%">
                <a-input-password
                  v-model="form.newPassword"
                  placeholder="请输入"
                  size="large"
                  style="width: 240px"
                />
              </a-form-model-item>
            </a-col>
            <a-col :span="11">
              <a-form-model-item label="再次输入" prop="confirmPassword" style="width: 100%">
                <a-input-password
                  v-model="form.confirmPassword"
                  placeholder="请输入"
                  size="large"
                  style="width: 240px"
                />
              </a-form-model-item>
            </a-col>
          </a-row>

          <div class="form-action-center">
            <a-button size="large" class="action-btn prev-btn" @click="handlePrevStep">上一步</a-button>
            <a-button type="primary" size="large" class="action-btn" @click="handleResetPassword">确定</a-button>
          </div>
        </a-form-model>
      </div>
    </div>
  </a-modal>
</template>

<script>
import { findPassword } from '@/api/login';
import VerifyCodeInput from '@/components/VerifyCodeInput';

export default {
  name: 'ForgetPasswordModal',
  components: {
    VerifyCodeInput
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    type: {
      type: String,
      default: ''
    }
  },
  data() {
    const validateConfirmPassword = (rule, value, callback) => {
      if (value !== this.form.newPassword) {
        callback(new Error('两次输入的密码不一致'));
      } else {
        callback();
      }
    };
    return {
      step: 1,
      form: {
        phone: '',
        code: '',
        newPassword: '',
        confirmPassword: ''
      },
      rules: {
        phone: [{ required: true, message: '请输入手机号', trigger: 'blur' }],
        code: [{ required: true, message: '请输入验证码', trigger: 'blur' }],
        newPassword: [{ required: true, message: '请输入新密码', trigger: 'blur' }],
        confirmPassword: [
          { required: true, message: '请再次输入密码', trigger: 'blur' },
          { validator: validateConfirmPassword, trigger: 'blur' }
        ]
      }
    };
  },
  computed: {
    smsCodeType() {
      if(this.type === 'supplier'){
        return 4;
      }else{
        return 3;
      }
    }
  },
  watch: {
    visible(val) {
      if (val) {
        this.step = 1;
        this.form = {
          phone: '',
          code: '',
          newPassword: '',
          confirmPassword: ''
        };
        this.$nextTick(() => {
          if (this.$refs.verifyCodeInput) {
            this.$refs.verifyCodeInput.stopCountdown();
          }
        });
      }
    }
  },
  methods: {
    handleCancel() {
      this.$emit('update:visible', false);
    },
    handleNextStep() {
      this.$refs.step1Form.validate(valid => {
        if (valid) {
          this.step = 2;
        }
      });
    },
    handlePrevStep() {
      this.step = 1;
    },
    handleResetPassword() {
      this.$refs.step2Form.validate(valid => {
        if (valid) {
          const data = {
            phone: this.form.phone,
            smsCode: this.form.code,
            passWord: this.form.newPassword,
            confirmPassWord: this.form.confirmPassword,
            smsCodeType: this.smsCodeType
          };
          findPassword(data).then(res => {
            this.$message.success('密码重置成功，请重新登录');
            this.$emit('update:visible', false);
          });
        }
      });
    }
  }
};
</script>

<style lang="less" scoped>
// Forget Password Modal Styles
.forget-modal-content {
  height: 100%;
  display: flex;
  flex-direction: column;
}

.modal-header {
  position: relative;
  text-align: center;
  margin-bottom: 80px;
  margin-top: 20px;
  
  .modal-title {
    font-size: 32px;
    color: #333;
    font-weight: 500;
  }
}

.step-content {
  flex: 1;
  padding: 0 40px;
}

.step-form {
  width: 100%;
  
  /deep/ .ant-form-item-label {
    width: 90px;
    text-align: right;
  }
  
  /deep/ .ant-input,
  /deep/ .ant-input-password {
    // border: 1px solid #d9d9d9;
    box-shadow: none;
    
    &:hover, &:focus {
      border-color: #5772c3;
    }
  }
}

.form-action-center {
  text-align: center;
  margin-top: 40px;
  
  .action-btn {
    width: 200px;
    height: 45px;
    background: #5b7adb;
    border-color: #5b7adb;
    
    &:hover {
      background: #4a65c5;
      border-color: #4a65c5;
    }

    &.prev-btn {
      background: #fff;
      border-color: #d9d9d9;
      color: rgba(0, 0, 0, 0.65);
      margin-right: 20px;
      
      &:hover {
        background: #fff;
        border-color: #5b7adb;
        color: #5b7adb;
      }
    }
  }
}
</style>